/**
 * The version of the rules, terms and privacy notice a player has agreed to: the date they last
 * changed. Bump it whenever any of the three changes in substance, and every player is asked to
 * agree again on their next visit.
 */
export const TERMS_VERSION = '2026-10-16';
